import CommentFormRow from "./CommentFormRow";
import PinkButton from "./PinkButton";
import ErrorMessage from "./ErrorMessage";
import { useState, useRef, useEffect } from 'react';
import { router, useForm } from '@inertiajs/react';
import ReactGA from 'react-ga4';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import Editor from './Editor';
import Quill from 'quill';

const CommentForm = ({ user, letter, is_tmobile, is_op }) => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [sendError, setSendError] = useState(false);
    const [error_message, setErrorMessage] = useState('');
    const [fpHash, setFpHash] = useState('');  

    // Use a ref to access the quill instance directly
    const quillRef = useRef();

    const noToolbarsPlease = { toolbar: [] };

    const { transform, data, setData, post, reset, processing, errors } = useForm({
        name: "",
        email: "",
        use_mod: false,
        use_op: false,
    });    

    transform((data) => ({
        ...data,
        message: JSON.stringify(quillRef.current.getSemanticHTML()),
        letter_id: letter.id,
    }));    
    
    useEffect(() => {
        const setFp = async () => {
          const fp = await FingerprintJS.load();
    
          const { visitorId } = await fp.get();
    
          setFpHash(visitorId);
        };
    
        setFp();
    }, []); 

    function handleSubmit(e) {
        
        e.preventDefault();

        setSendError(false);
        setIsSubmitting(true);        

        axios.post('/comments/add', {
            name: data.name,
            email: data.email,
            use_mod: data.use_mod,
            use_op: data.use_op,
            message: JSON.stringify(quillRef.current.getSemanticHTML()),
            letter_id: letter.id,    
            guid: fpHash,
        }).then(function (res) {

            setIsSubmitting(false);

            if(res.data.success == false) {
                setSendError(true);
                setErrorMessage(res.data.error_message);
            } else {

                let event_params = {
                    "category": "comment",
                    "action": "add",
                    "label": "send"
                };

                ReactGA.event("comment", event_params);                

                router.visit(route('letter.details', {id: letter.id}));

            }
            
        })
        .catch(function (error) {

            console.log(error);

            setIsSubmitting(false);
            setSendError(true);
            setErrorMessage(error.message);

            console.log(error.message.data);            
        });

        /*
        router.post('/comments/add', {
            onStart: () => {
                console.log("go");
            },
            onSuccess: () => {
                quillRef.current.clipboard.dangerouslyPasteHTML("<p></p>", 'silent');                
                reset();
            },
            onError: (errors) => {
                console.log("error");
            }
        });
       */

    }    

    var l = 0;
    if(user) {
        l = user.l;
    }

    return (
      <div key="commentContainer-addComment" className="text-[0.8em]">

        {letter.disable_comments == true && (
            <div className="flex flex-col gap-y-2 text-xs border border-dotted border-black letterContainer py-[25px] px-[10px] my-[10px]">
                    <span className="font-bold w-full text-center">Comments have been disabled by the writer.</span>
                    <span className="w-full text-center">Please respect their wishes and do not respond.</span>                        
            </div>
        )}

        {(letter.disable_comments == false || l > 0) && (
        <>
            <div className="flex flex-col letterContainer py-[10px]">

                <form id="comment-add-form" onSubmit={handleSubmit}>

                            <h4 id="add" className="text-[1.1em] font-bold">add comment

                                {(letter.disable_comments == true && l > 0) && (
                                    <span className="text-xs px-2 font-light">(this form seen by mods only)</span>
                                )}

                            </h4>

                            <CommentFormRow label="Name:" htmlFor="name">
                                <input type="text" id="name" placeholder="anonymous lover" className="px-[10px] py-[5px] text-[14px] w-full border border-[#ccc] rounded-md" value={data.name} onChange={e => setData('name', e.target.value)}></input>
                            </CommentFormRow>

                            {is_op && (
                                <>
                                <div className="mt-[5px] mb-[15px] flex items-center">
                                    <input type="checkbox"
                                      id="use_op"
                                      className="mr-[5px] w-4 h-4 text-pink bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2"
                                      checked={data.use_op} onChange={e => setData('use_op', e.target.checked)} />
                                    <label htmlFor="use_op">
                                        Display "
                                          <svg xmlns="http://www.w3.org/2000/svg" 
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className={`relative pr-[2px] top-[-2px] inline w-[14px] md:w-[15px] text-pink`}
                                          >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                                          </svg>
                                        original poster" as commenter name
                                    </label>
                                </div>
                                </>

                            )}

                            <CommentFormRow label="Email:" htmlFor="email">
                                <input type="text" id="email" className="px-[10px] py-[5px] text-[14px] w-full border border-[#ccc] rounded-md" value={data.email} onChange={e => setData('email', e.target.value)}></input>
                                {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
                                <p className="leading-snug text-[0.8em] mt-[5px]">Email is optional and never shown. Leave yours if you want email notifications on new comments for this letter.</p>                    
                            </CommentFormRow>


                            <CommentFormRow className="addCommentHolder" label="Comment:" htmlFor="message">
                                <Editor
                                    modules={noToolbarsPlease}
                                    ref={quillRef}
                                />
                            </CommentFormRow>

                            {l > 0 && (
                                <>
                                <div className="my-[10px]">
                                    <label htmlFor="use_mod">
                                        <input type="checkbox" id="use_mod" className="mr-[5px]" checked={data.use_mod} onChange={e => setData('use_mod', e.target.checked)} />
                                        Display "moderator" as commenter name
                                    </label>
                                </div>
                                </>
                            )}

                            <div>
                                <p className="leading-snug text-[0.8em] mt-[5px] mb-0">
                                    Please read our <a href="/terms" className="text-pink" target="_blank">Terms of Use</a> and <a href="/privacy" className="text-pink" target="_blank">Privacy Policy</a> before commenting.
                                </p>
                            </div>

                            <div>
                                <PinkButton isSubmitting={isSubmitting} label="Send"></PinkButton>
                            </div>

                            <div className={`duration-100 ${!sendError ? "hidden" : "block"}`}>
                                <div className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                                    <p dangerouslySetInnerHTML={{ __html: error_message }}></p>
                                    <p className="mb-0">Need help? Contact <a href="mailto:letters.to.crushes@gmail.com">letters.to.crushes@gmail.com</a>.</p>
                                </div>
                            </div>

                            <div className={`duration-100 ${!is_tmobile ? "hidden" : "block"}`}>
                                <div className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                                    <p>You are visiting from a T-Mobile IP address.</p>
                                    <p>In the future, you may be required to <a href="/login">login</a> or <a href="/register">create an account</a> to post comments if you are on a T-Mobile IP address.</p>
                                    <p>We apologize but this is due to increased trolling from these IP addresses. For more information please see this letter: <a href="/letter/1005208">letter #1005208</a>. Thank you for helping make letters to crushes a safe space.</p>
                                    <p className="mb-0">Need help? Contact <a href="mailto:letters.to.crushes@gmail.com">letters.to.crushes@gmail.com</a>.</p>
                                </div>
                            </div>


                            <div className="leading-snug m-[5px] p-[10px] mb-0 border-gray-200">
                                <p className="text-center mb-0">Please, no projections</p>

                                <ul className="list-outside list-disc mt-2 mx-6">
                                    <li>This is a small site. Your crush <strong>is not here</strong>.</li>
                                    <li>Leave a comment to help or support the author. Do not try to break their anonymity.</li>
                                    <li>Report comments and letters that project.</li>
                                </ul>

                            </div>

                </form>

            </div>

        </>

        )}

        </div>   

    ); 
  };

export default CommentForm;